import { message, Modal } from "antd";
import { IPageAddCallback, api } from "./index";
import { openPicker as openCategoriesPicker } from "../components/CategoriesPickerTree";
import { getPermissions } from "../permissions";
import { PermissionEnum } from "../const";
import { lang } from "../context";
import events from "../context/events";
import { analysisLog } from "@/utils/logAnalytics";
import { emit } from "process";
import { copyTips, getSpaceIdByRootId, moveTips } from "../util";
import { ActionType, MenusType } from "../types";

// eslint-disable-next-line max-params
const copy: IPageAddCallback = (props, isAllow, isTeam, globalContext, currentRouterInfo) => {
  const { data, reload, gname = "", name = "", originId } = props;
  const defaultNav = gname
    ? [
        {
          name: gname,
          id: data?.space_id,
          icon: "iconapp_btn_folder",
          level: 1,
          isLeaf: false,
          type: 3,
          disabled: false,
          selectable: true
        }
      ]
    : null;
  const callback = () => {
    openCategoriesPicker({
      isCopy: true,
      defaultNav,
      title: data.title || data.name || "无标题",
      selectArray: [
        {
          id: props.data.id,
          rootId: props.data.space_id,
          type: "file"
        }
      ],
      reload,
      canSelectMy: true,
      isTeam: isTeam,
      appRuntimeEnv: globalContext?.appRuntimeEnv,
      from: name,
      originId,
      isGroupSpace: gname ? true : false,
      callback: async (o, close) => {
        let spaceId: any;
        let categoryId: any;

        // 如果是到共享文件夹需要判断是不是到根文件夹
        if (o.type === 12) {
          // spaceId = rootId;
          categoryId = o.id;
        } else {
          // 如果是到我的文件夹需要都置空
          categoryId = o.id === "root" ? "" : o.id;
        }
        const tip: any = copyTips(props.data, o, isTeam);
        Modal.confirm({
          content: lang(tip, { name: o.name }),
          title: lang("ctx.copy.tips.title"),
          // content:
          //     '移动后将取消原文件夹协作者的共享，并重新共享给目标文件夹的协作者。',
          cancelText: lang("common.cancel"),
          okText: lang("common.confirm"),
          onOk: () => {
            analysisLog("xtbg_jzb_joyspace_home_1676548210761", "13", name, categoryId);
            api.batch
              .batchCopy({ pageIds: [data.id], folderId: categoryId, spaceId } as any)
              .then((res) => {
                const { data, status } = res;
                if (data) {
                  message.success(lang("common.success"));
                  console.log(originId, "文档复制到==>", o.id);
                  const res = getSpaceIdByRootId(originId, o.id);
                  // 如果选中的是当前目录刷新
                  if (res) {
                    events.emit("list.reload", {
                      actionType: ActionType.Page
                    });

                    // events.emit("joyspace.list:batchAddFileAll", data1);
                  }
                  // 如果是首页，更新最近列表
                  events.emit("list.reload", {
                    key: MenusType.RECENT
                  });
                  events.emit("list.check");
                } else {
                  message.error(status);
                }
                close();
              })
              .catch((e) => {
                e && message.error(e);
                close();
              });
          }
        });
      }
    });
  };

  return [
    {
      children: lang("ctx.copy.title.suffix"),
      callbackOrModal: callback,
      isAllow,
      type: "copy",
      icon: "pc_yundoc_copy",
      splitCode: 2,
      tip: "在选中目标位置创建一个副本文件，内容与原件一致，但两份文件互相独立。",
      allowTips: data.permissions.includes(PermissionEnum.SECURES_OPEN)
        ? "文档已开启安全设置，您暂无权限复制"
        : ""
    }
  ];
};

export default copy;
